import { render, staticRenderFns } from "./PopupContentLoader.vue?vue&type=template&id=620ae08c&scoped=true"
import script from "./PopupContentLoader.vue?vue&type=script&lang=js"
export * from "./PopupContentLoader.vue?vue&type=script&lang=js"
import style0 from "./PopupContentLoader.vue?vue&type=style&index=0&id=620ae08c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ae08c",
  null
  
)

export default component.exports